import o from "./ghl-ui.es728.js";
var t = function() {
  return o.Date.now();
};
const r = t;
export {
  r as default
};
